var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Error")]),_c('p',{staticClass:"mt-3"},[_vm._v("予期せぬエラーが生じました。")])])}]

export { render, staticRenderFns }